import axios from 'axios'

const MaterialCall = {
  async deleteAnnotation(id) {
    const url = `${window.viewer.api}annotations/${id}`
    try {
      const response = await axios.delete(url)
      return response
    } catch (error) {
      return error
    }
  },

  async getAnnotations(userBookId, sectionId) {
    const params = { sectionId, userBookId }
    const url = `${window.viewer.api}annotations`
    try {
      const response = await axios.get(url, { params })
      return response.data
    } catch (error) {
      return error
    }
  },

  async setAnnotations(data) {
    const url = `${window.viewer.api}annotations`
    try {
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      return error
    }
  },

  async updateAnnotation(data) {
    const url = `${window.viewer.api}annotations/${data.id}`
    try {
      const response = await axios.patch(url, data)
      return response
    } catch (error) {
      return error
    }
  },
}
export default MaterialCall
